import ListItemColumn from './ListItemColumn'

export default ListItemColumn



// WEBPACK FOOTER //
// ./src/components/List/Item/Column/index.js